import { Col, Row } from 'react-bootstrap';
import { CurrentLocationCard } from '../location-details/ViewLocationCard'; 

export function ViewLocation() {
  return (
    <>
      <Row>
        <Col md={12}>
          <CurrentLocationCard />
        </Col>
      </Row>
    </>
  );
}
